let toggles: HTMLInputElement[] = [];
let radios: HTMLInputElement[] = [];

export const initDarkModeToggles = ($parentContainer: HTMLElement): void => {
  const localToggles = $parentContainer.querySelectorAll<HTMLInputElement>('.theme-toggle')
  const localRadios = $parentContainer.querySelectorAll<HTMLInputElement>('.theme-radio')

  localToggles.forEach(toggle => {
    toggles.push(toggle);
  })
  localRadios.forEach(radio => {
    radios.push(radio);
  })

  const syncTheme = (isDarkMode: boolean): void => {
    toggles.forEach((toggle: HTMLInputElement) => {
      toggle.checked = isDarkMode;
    });
    radios.forEach((radio: HTMLInputElement) => {
      radio.checked = radio.value === (isDarkMode ? 'dark' : 'light');
    });
    localStorage.setItem('hs_theme', isDarkMode ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', isDarkMode);
  };

  localToggles.forEach((toggle: HTMLInputElement) => {
    toggle.addEventListener('change', (e: Event) => {
      const target = e.target as HTMLInputElement;
      const isDarkMode = target.checked;
      syncTheme(isDarkMode);
    });
  });

  localRadios.forEach((radio: HTMLInputElement) => {
    radio.addEventListener('change', (e: Event) => {
      const target = e.target as HTMLInputElement;
      const isDarkMode = target.value === 'dark';
      syncTheme(isDarkMode);
    });
  });

  const isDarkMode: boolean = document.documentElement.classList.contains('dark');
  syncTheme(isDarkMode);
};